export default __webpack_public_path__ + "static/media/videoPlay.fe47c3f7.svg";